import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label-box"
}
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_form_input = _resolveComponent("form-input")!

  return (_ctx.modelValue || _ctx.editing)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.isColor)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "color",
              style: _normalizeStyle({'background-color': _ctx.modelValue})
            }, null, 4))
          : _createCommentVNode("", true),
        (!_ctx.editing)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.modelValue), 1))
          : (_ctx.editing)
            ? (_openBlock(), _createBlock(_component_q_select, {
                key: 2,
                label: _ctx.label?.length ? _ctx.label : undefined,
                "model-value": _ctx.modelValue,
                options: _ctx.filterOptions,
                onInputValue: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$emit('update:model-value', $event); _ctx.setInputWidth($event)}),
                onFilter: _ctx.selectFilter,
                "popup-content-style": "padding: 0;",
                "new-value-mode": "add-unique",
                "input-debounce": "0",
                ref: "qSelect",
                "hide-selected": "",
                "options-dense": "",
                borderless: "",
                "use-input": "",
                dense: "",
                "fill-input": "",
                "emit-value": "",
                "stack-label": ""
              }, null, 8, ["label", "model-value", "options", "onFilter"]))
            : (_openBlock(), _createBlock(_component_form_input, {
                key: 3,
                "model-value": _ctx.modelValue,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:model-value', $event)))
              }, null, 8, ["model-value"]))
      ]))
    : _createCommentVNode("", true)
}